import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AssignedPrivileges } from '@shared/models/assigned-privileges.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PrivilegeService {
  private http = inject(HttpClient);
  private resourceUrl = '/api/finance-privileges';

  getLocalPrivileges(): Observable<AssignedPrivileges> {
    return this.http.get<AssignedPrivileges>(`${this.resourceUrl}/account`);
  }
}
